import { languageIndex } from "@utils";
export const fields = (language) => {
    const index = languageIndex(language);
    return {
        template: ["Template", "Шаблон"][index],
    };
};
